<script>
const random = () => {
  const buf = new Uint8Array(1);
  crypto.getRandomValues(buf)
  return buf[0]
}
export default {
  name: 'ChartMix',
  props: {
    graphTitle: { required: true, type: String },
    loading: { required: true, type: Boolean },
    initTitle: { default: 'Carregando dados...' },
    loadTitle: { default: 'Carregando...' },
  },
  data: () => ({
    currentTitle: '',
    setIntervalName: `setIntervalChartMix${random()}`
  }),
  mounted() {
    this.currentTitle = this.initTitle
    this.createChart()

    this[setInterval] = setInterval(() => {
      if (!this.$refs.targetChart) return
      const el = this.$refs.targetChart.querySelector('svg > text.highcharts-title')
      if (el)
        el.innerHTML = this.currentTitle
    }, 1000)
  },
  destroyed() {
    clearInterval(this[setInterval])
  },
  watch: {
    loading(value) {
      this.currentTitle = this.loading ? this.loadTitle : this.graphTitle
      if (!value)
        this.createChart()
    }
  }
}
</script>